module.exports = __webpack_public_path__ + "media/הלך.683a3a2d.mp3";